import request from "@/utils/request";
const Api = {
    // 发送验证码
    sendCode: (params) => {
        return request({
            url: "/aicheckapi/user/login/sendCode",
            method: "post",
            data: params,
        });
    },
    //登录
    login: (params) => {
        return request({
            url: "/aicheckapi/user/login",
            method: "post",
            data: params,
        });
    },
    //注册发送验证码
    registerSendCode: (params) => {
        return request({
            url: "/aicheckapi/user/register/sendCode",
            method: "post",
            data: params,
        });
    },
    //注册
    register: (params) => {
        return request({
            url: "/aicheckapi/user/register",
            method: "post",
            data: params,
        });
    },
    //申请测试
    applyTrial: (params) => {
        return request({
            url: "/aicheckapi/applyTest/save",
            method: "post",
            data: params,
        });
    },
    //申请状态
    checkApplyStatus: () => {
        return request({
            url: "/aicheckapi/applyTest/detail",
            method: "post",
        });
    },
    //文本检测
    textCheck: (params) => {
        return request({
            url: "/aicheckapi/check/text",
            method: "post",
            data: params,
        });
    },
    //图片检测
    imageCheck: (params) => {
        return request({
            url: "/aicheckapi/check/img",
            method: "post",
            data: params,
        });
    },
    //视频检测
    videoCheck: (params) => {
        return request({
            url: "/aicheckapi/check/video",
            method: "post",
            data: params,
        });
    },
    // 音频检测
    audioCheck: (params) => {
        return request({
            url: "/aicheckapi/check/audio",
            method: "post",
            data: params,
        });
    },
    //获取oss token
    getOssToken: (params) => {
        return request({
            url: "/aicheckapi/common/sts/token/public",
            method: "post",
            data: params,
        });
    },
    //获取检测结果
    getCheckResult: (params) => {
        return request({
            url: "/aicheckapi/check/result/get",
            method: "post",
            data: params,
        });
    },
    //修改密码发送验证码
    changePassSendCode: (params) => {
        return request({
            url: "/aicheckapi/user/password/update/sendCode",
            method: "post",
            data: params,
        });
    },
    //修改密码
    changePassword: (params) => {
        return request({
            url: "/aicheckapi/user/password/update",
            method: "post",
            data: params,
        })
    },
    //校验token
    verifyToken: () => {
        return request({
            url: "/aicheckapi/user/token/check",
            method: "post",
        })
    },


}
export default Api;


// WEBPACK FOOTER //
// ./src/api/index.js